import { getTranslations } from './index.js';
import { version } from '../version.js';

const [ MAJOR_VERSION ] = version.split('.');

export const TRANSLATION_COMPLETE_EVENT_NAME = 'pr-document-translation-complete';

export class TranslationComponent extends HTMLElement {
    static get tagName() {
        return `pr-document-translation-v${MAJOR_VERSION}`;
    }

    async connectedCallback() {
        const language = this.getAttribute('language');
        const translations = await getTranslations({ language });

        const translationKey = this.getAttribute('key');
        const translation = await translations.getTranslation(translationKey);

        const textNode = document.createTextNode(translation);

        this.dispatchEvent(new CustomEvent(TRANSLATION_COMPLETE_EVENT_NAME, {
            detail: {
                key: translationKey
            },
            bubbles: true,
            cancelable: true,
            composed: true
        }));
        this.replaceWith(textNode);
    }
}

if (!customElements.get(TranslationComponent.tagName)) {
    customElements.define(TranslationComponent.tagName, TranslationComponent);
}
